__webpack_require__.p = "/dev/wip-remove-minimap/";